import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import layer from "layer";

import "element-ui/lib/theme-chalk/index.css";

import routers from "./router/index";
import VueRouter from "vue-router";

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(layer);

const router = new VueRouter({
  routes: routers, // 这里改为 routes
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
